"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GRID_DETAIL_PANEL_TOGGLE_FIELD = void 0;
// Can't import from pro package - hence duplication
const GRID_DETAIL_PANEL_TOGGLE_FIELD = '__detail_panel_toggle__';
exports.GRID_DETAIL_PANEL_TOGGLE_FIELD = GRID_DETAIL_PANEL_TOGGLE_FIELD;